export const RemoveSpacesRepository = Symbol('RemoveSpacesRepository');
export const RemoveSpacesService = Symbol.for('RemoveSpaceService');
